import endpoints from "../config/apiConfig";
import axiosInstance from "../config/axiosInstance";
import { ChangePasswordPayload, LoginPayload } from "../types/payload";

const loginService = (payload: LoginPayload) => {
  return axiosInstance.post(endpoints.login, payload);
};
const changePassword = (payload: ChangePasswordPayload) => {
  return axiosInstance.post(endpoints.changePassword, payload);
};

const getRolePermissions = (params: { role_id: string }) => {
  return axiosInstance.get(endpoints.rolePermission, { params });
};

export { loginService, getRolePermissions, changePassword };
